/*
 * @Author: Tina Huang
 * @Date: 2024-04-30 14:33:54
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 16:10:03
 * @Description:
 */

import { Col, Row, Form, Button, Switch } from 'antd'
import { useEffect, useState } from 'react'
import domtoimage from 'dom-to-image'
import { saveAs } from 'file-saver'
import Preview from './preview'
import ReceiptForm from './form'
import { TypesKey, ReceiptTypes } from '@/constants/creator'
// import styles from './index.module.css'

type ReceiptType = {
  border: Boolean
  orderCode: String
  orderNumber: string
  orderName: string
  orderType: string
  orderContent: string
  orderEnglish?: string
  orderCus: string
  orderTime: string
  orderMode?: string
  orderClass?: string
  orderMessage?: string
  orderStore?: string
  orderPlatfrom?: string
}

export default function ReceiptCreator() {
  const [form] = Form.useForm()
  const FormItem = Form.Item
  const [formValues, setFormValues] = useState<ReceiptType>()
  const [loading, setLoading] = useState(false)
  const [type, setType] = useState(TypesKey.GoodMe)

  useEffect(() => {
    const _init = {
      orderCode: 'W806',
      orderName: '阿汪** 女士',
      orderMode: '自取-打包 1/1',
      orderContent: '超A芝士葡萄[大]',
      orderCus: '沙冰｜五分甜[T5]',
      orderTime: '09-03 12:11',
      orderClass: 'V1',
      orderMessage: '灵感常驻 清爽真果茶',
      orderStore: '这里是一家店铺 100000000',
      orderStep: '*【Ls140、Lm1】#【T10、C170、N2、B5、+T5、+C8】',
      orderPlatfrom: '微信小程序',
      orderType: '大杯',
    }
    setFormValues({ ...form.getFieldsValue(), border: true, ..._init })

    document.title = '小票生成器 · 阿汪同学'
  }, [form])

  const handleChange = (e: any) => {
    setFormValues(form.getFieldsValue())
  }
  // 生成图片自动下载为png格式（将dom转为二进制再编译下载）
  const getBlobPng = () => {
    setLoading(true)
    const node = document.getElementById('node') as any
    console.log(node)
    domtoimage.toBlob(node).then((blob: any) => {
      // 调用file-save方法 直接保存图片
      saveAs(blob, `${formValues?.['orderContent']}${formValues?.['orderTime']}.png`)
      setLoading(false)
    })
  }

  return (
    <div>
      <Row>
        <Col span={3}>
          <h1 className="text-center mb-4 font-bold">奶咖小票</h1>
          {ReceiptTypes.map((item) => (
            <Button
              type={type === item.value ? 'primary' : 'default'}
              size="large"
              block
              className="mb-2 mr-2"
              onClick={() => setType(item.value)}
            >
              {item.label}
            </Button>
          ))}
        </Col>
        <Col span={1} />
        <Col span={6}>
          <h1 className="text-2xl font-bold mb-4">小票预览</h1>
          <Preview type={type} formValues={formValues} />
          <Button disabled={!type} type="primary" className="m-auto mt-4" loading={loading} onClick={getBlobPng} style={{ width: 230 }}>
            导出下载
          </Button>
        </Col>
        {/* <Col span={2} /> */}
        <Col span={8}>
          <h1 className="text-2xl font-bold">小票生成器</h1>
          <Form
            form={form}
            initialValues={{
              border: true,
            }}
            labelCol={{ span: 6 }}
            className="mt-4"
            onChange={handleChange}
          >
            <FormItem label="是否带边框" name="border" valuePropName="checked">
              <Switch onChange={handleChange} />
            </FormItem>
            <ReceiptForm type={type} />
          </Form>
        </Col>
      </Row>
    </div>
  )
}
